var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInputError = function SvgIconInputError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm2.696 5.304a.727.727 0 0 1 0 1.028L9.03 8l1.667 1.668a.727.727 0 0 1-1.028 1.028L8 9.03l-1.668 1.667a.727.727 0 0 1-1.028-1.028L6.97 8 5.304 6.332a.727.727 0 0 1 1.028-1.028L8 6.97l1.668-1.667a.727.727 0 0 1 1.028 0Z",
    fill: "#DB0000"
  })));
};
export default SvgIconInputError;